<template>
  <div class="w-full flex flex-col mt-2 pr-2 sm:pr-5">
    <label class="text-[var(--color-disabled)] text-lg">{{ this.question }}</label>
    <label v-if="!this.editable" class="text-lg break-words">{{ this.displayAnswer }}</label>
    <Textarea
      v-if="this.editable"
      :disabled="!this.isEditable"
      maxlength="500"
      @input="handleText"
      v-model="this.localAnswer"
      class="text-base h-24"
    />
  </div>
</template>
<script>
import { Textarea } from 'primevue';

export default {
  name: 'PersonalGoalsQnAComponent',
  components: { Textarea },
  props: ['qna', 'editable'],
  data() {
    return {
      localAnswer: this.qna.answer || '',
    };
  },
  computed: {
    isEditable() {
      return this.editable;
    },
    question() {
      const key = 'q'.concat(this.qna.questionKeyword.replace('?', ''));
      return this.$t(`PersonalGoals.${key}`);
    },
    displayAnswer() {
      return this.qna.answer || '';
    },
  },
  watch: {
    'qna.answer': function (newValue) {
      this.localAnswer = newValue || '';
    },
  },
  methods: {
    handleText(event) {
      const updatedValue = this.$store.getters.getGoalUpdateObject;
      const questionKey = this.qna.questionKeyword;
      updatedValue[questionKey] = event.target.value;
      this.$store.commit('setGoalUpdateObject', updatedValue);
    },
  },
};
</script>
